export default "__VITE_ASSET__De_wc6VG__"